import { mascaras } from '../../constants'

// a mascara sai do formato da data: as barras (e os dois pontos da hora) entram sozinhos ao digitar, e data colada
// ja formatada tambem e aceita. So cobre dia, mes e ano numericos; formato com nome de mes fica sem mascara
const FORMATO_NUMERICO = /^(dd|mm|yy)([/.-](dd|mm|yy))*$/
const MASCARA_HORA = ' 99:99'

export function derivarMascara(dateFormat, showTime) {
  const formato = dateFormat || mascaras.MASCARA_DATA_DD_MM_YY
  if (!FORMATO_NUMERICO.test(formato)) {
    return undefined
  }
  const mascara = formato.replace(/dd|mm/g, '99').replace(/yy/g, '9999')
  return showTime ? mascara + MASCARA_HORA : mascara
}

// fora da visao de mes o Calendar nao entende texto sem dia e descarta "08/2026" digitado; vale o dia primeiro
export function parseMesAno(texto) {
  const partes = /^(\d{2})\/(\d{4})$/.exec(texto)
  const mes = partes ? parseInt(partes[1], 10) : 0
  if (mes < 1 || mes > 12) {
    throw new Error('Invalid date')
  }
  return new Date(parseInt(partes[2], 10), mes - 1, 1)
}

// na visao de mes a data e sempre o dia primeiro. O botao "Hoje" da barra do Calendar entrega o dia corrente, e uma
// competencia com dia 8 nao bate com as gravadas no dia 1
export function primeiroDiaDoMes(data) {
  if (Object.prototype.toString.call(data) !== '[object Date]' || data.getDate() === 1) {
    return data
  }
  return new Date(data.getFullYear(), data.getMonth(), 1)
}
